<template>
  <div id="botao-voltar">
    <button @click="$router.back()">< voltar</button>
  </div>
  <Carregamento v-if="carregando" />
  <div
    id="content-tarefa"
    v-else
  >
    <div id="top-content-tarefa">
      <div id="titulo-tarefa">
        <div class="titulo-e-estado">
          <h4>{{ tarefa.titulo?.toUpperCase() }}</h4>
          <span>{{ formatarEnum(tarefa.estadoDescricao) }}</span>
        </div>
        <div id="status-tarefa">
          <span>Inicio: {{ formatarData(tarefa.dataInicio) }}</span>
        </div>
        <div id="data-conlusao">
          <span> Data de conclusão: {{ formatarData(tarefa.dataFim) }} </span>
        </div>
        <div id="status">
          <span>Status: {{ formatarEnum(tarefa.statusDescricao) }}</span>
        </div>

        <div id="descricao-tarefa">
          <p>
            <span>Descrição:</span> <span>{{ tarefa.descricao }}</span>
          </p>
        </div>
      </div>
      <div
        id="progresso"
        :class="{ progressoAlterar: alterarPorcentagem }"
      >
        <h6 id="h6-style">
          Progresso: {{ tarefa.percentualConclusao }}%
          <button
            class="tarefa-btn"
            :class="{ fecharProgresso: alterarPorcentagem }"
            :disabled="
              tarefa.estadoDescricao == 'EM_EDICAO' ||
              tarefa.estadoDescricao == 'CONCLUIDA' ||
              tarefa.estadoDescricao == 'CANCELADA'
            "
            v-if="lider || isCordenadorAcao"
            @click="alterarProgresso"
          >
            Alterar progresso
          </button>
        </h6>
        <div
          class="sub-tarefa-inputs-pai"
          v-if="alterarPorcentagem"
        >
          <div class="sub-tarefa-inputs">
            <div class="sub-tarefa-inputs-top">
              <h6>REGISTRAR PROGRESSO</h6>
              <h6
                style="cursor: pointer"
                @click="
                  ((alterarPorcentagem = !alterarPorcentagem),
                  (erro = ''),
                  (porcentagemNova = 0))
                "
              >
                X
              </h6>
            </div>
            <div class="sub-tarefa-all-inputs">
              <form
                class="btns"
                @submit.prevent="putPorcentagem()"
              >
                <div class="subTarefa-titulo-input">
                  <h4>Progresso atual: {{ tarefa.percentualConclusao }}%</h4>
                  <div>
                    <label
                      for=""
                      style="font-size: 18px"
                      >Novo progresso:</label
                    >
                    <input
                      class="num-porcentagem"
                      type="number"
                      min="0"
                      max="100"
                      v-model="porcentagemNova"
                    />%

                    <input
                      type="range"
                      name=""
                      id=""
                      class="btn-porcentagem"
                      v-model.number="porcentagemNova"
                    />
                  </div>
                </div>
                <div class="div-sub-tarefa-btn">
                  <div
                    v-if="erro"
                    class="error-message"
                  >
                    {{ erro }}
                  </div>
                  <div
                    v-if="dataInicioEFimMaiorAtual"
                    class="error-message"
                  >
                    {{ dataInicioEFimMaiorAtual }}
                  </div>
                  <button
                    class="sub-tarefa-btn sub-tarefa-btn-porcentagem"
                    type="submit"
                  >
                    Salvar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />

    <div id="middle-content-tarefa">
      <div class="contribuidores-sub-tarefas">
        <div id="contribuidores">
          <h4 id="h6-style">Contribuidores:</h4>
          <div
            id="contribuidores-bottom"
            v-if="colaboradores?.length > 0"
          >
            <div
              v-for="(colaborador, index) in colaboradores"
              :key="index"
            >
              <img
                src="@/assets/icons/user.png"
                width="25px"
                height="25px"
                alt=""
              />
              <p>{{ colaborador }}</p>
            </div>
          </div>
          <div v-else>
            <p>Não há contribuidores nessa tarefa!</p>
          </div>
          <div
            v-if="AddColaboradorCampo"
            id="addColaboradorCampo"
          >
            <select
              id="select-colaboradores"
              v-model="membroSelecionado"
            >
              <option
                hidden
                disabled
                :value="{}"
              >
                Selecione um contribuidor
              </option>
              <option
                v-for="(membro, index) in membrosEquipeAtividade"
                :key="index"
                :value="membro"
              >
                {{ membro.nome }}
              </option>
            </select>
            <button
              @click="addColaborador"
              v-if="lider || isCordenadorAcao"
            >
              Adicionar Contribuidor
            </button>
          </div>
        </div>
        <br />

        <div id="sub-tarefas">
          <div id="sub-tarefa-top">
            <h4 id="h6-style">Subtarefas:</h4>
            <button
              v-if="lider || isCordenadorAcao || membroAlocado"
              :disabled="
                tarefa.estadoDescricao == 'EM_EDICAO' ||
                tarefa.estadoDescricao == 'CONCLUIDA' ||
                tarefa.estadoDescricao == 'CANCELADA'
              "
              class="tarefa-btn"
              @click="addSubTarefaCampo"
            >
              Cadastrar subtarefa
            </button>
          </div>
          <div id="sub-tarefa-middle">
            <div
              class="sub-tarefas-for"
              v-for="(subtarefa, index) in subTarefas"
              :key="index"
            >
              <!-- depois ajustar lógica para abrir apenas a subtarefa com a key, utilizando o v-for -->
              <div class="sub-tarefa">
                <p
                  @click="toggleSubtarefas(index)"
                  style="cursor: pointer"
                  :class="{ subTarefaAbertaP: verificarSubtarefaAberta(index) }"
                >
                  <i
                    class="fa-solid fa-angle-right"
                    :class="{ girarSeta: verificarSubtarefaAberta(index) }"
                  >
                  </i>
                  <span>{{ subtarefa.titulo }}</span>

                  ({{ verificarStatusSubtarefa(subtarefa) }})
                </p>
                <div
                  v-if="verificarSubtarefaAberta(index)"
                  class="sub-tarefa-aberta"
                >
                  <div class="sub-tarefa-data">
                    <span
                      >Data de início:
                      {{ formatarData(subtarefa.dataInicio) }}</span
                    >
                    <span
                      >Data de término:
                      {{ formatarData(subtarefa.dataFim) }}</span
                    >
                  </div>
                  <div class="criador-sub-tarefa">
                    <span
                      >Membro criador:
                      {{
                        subtarefa.membroCriador
                          ? subtarefa.membrocriado
                          : "Indefinido"
                      }}</span
                    >
                    <div v-if="subtarefa.membroCriado">
                      <img
                        src="@/assets/icons/user.png"
                        width="25px"
                        height="25px"
                        alt=""
                      />
                      <span>{{ subtarefa.membroCriador }}</span>
                    </div>
                  </div>
                  <div class="sub-tarefa-botoes">
                    <button
                      type="button"
                      :disabled="subtarefa.status === true"
                      @click="concluirSubtarefa(subtarefa)"
                    >
                      Concluir
                    </button>
                    <!-- <button
                      type="button" 
                     v-if="isSubtarefaCreator(subtarefa) && verificarEdicao()" :disabled="subtarefa.status"
                    @click="openEditSubTarefaCampo(subtarefa)">Editar</button> -->
                    <button
                      v-if="verificarEdicao()"
                      :disabled="subtarefa.status == true"
                      type="button"
                      @click="openEditSubTarefaCampo(subtarefa)"
                      class="btn-editar-subtarefa"
                    >
                      Editar
                    </button>
                    <button
                      type="button"
                      v-if="verificarExclusao()"
                      @click="excluirSubtarefaModalConfirmacao(subtarefa)"
                      style="background-color: red"
                    >
                      Excluir
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="subTarefas.length <= 0">
              <p style="color: red">
                Nenhuma subtarefa cadastrada até o momento
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="comentarios-main">
        <h6>COMENTÁRIOS</h6>
        <div class="comentarios-content">
          <!-- Comentários do usuário logado -->
          <div
            v-for="(mensagem, index) in mensagensDoUsuario"
            :key="'user-' + index"
            class="comentario-usuario-logado"
          >
            <h5>{{ mensagem.autor }}</h5>
            <p>{{ mensagem.mensagem }}</p>
          </div>

          <!-- Comentários de outros usuários -->
          <div
            v-for="(mensagem, index) in mensagensDeOutros"
            :key="'other-' + index"
            class="comentario-outro-usuario"
          >
            <h5>{{ mensagem.autor }}</h5>
            <p>{{ mensagem.mensagem }}</p>
          </div>
        </div>
        <div class="comentarios-input">
          <input
            @keyup.enter="enviarMensagem"
            v-model="mensagemInput"
            type="text"
            placeholder="Escreva algo..."
          />
          <button @click="enviarMensagem">Enviar</button>
        </div>
      </div>
    </div>
    <div class="div-button-editar">
      <button
        type="button"
        id="button-finalizar"
        @click="seVoluntariar"
        v-if="!membroAlocado"
        :disabled="
          tarefa.estadoDescricao == 'CONCLUIDA' ||
          tarefa.estadoDescricao == 'CANCELADA'
        "
      >
        Voluntariar-se
      </button>
      <div
        id="finalizar-section"
        v-if="lider || isCordenadorAcao"
      >
        <button
          type="button"
          id="button-finalizar"
          v-if="lider || isCordenadorAcao"
          @click="viewAlocarMembros = true"
          :disabled="
            tarefa.estadoDescricao == 'CONCLUIDA' ||
            tarefa.estadoDescricao == 'CANCELADA'
          "
        >
          Editar contribuidores
        </button>
        <button
          type="button"
          id="button-finalizar"
          @click="mudarEstado"
          v-if="lider || isCordenadorAcao"
        >
          {{
            tarefa.estadoDescricao == "EM_EDICAO"
              ? "Lançar tarefa"
              : "Retornar a edição"
          }}
        </button>
        <button
          id="button-finalizar"
          :disabled="
            tarefa.estadoDescricao == 'EM_EDICAO' ||
            tarefa.estadoDescricao == 'PARA_FAZER' ||
            tarefa.estadoDescricao == 'CONCLUIDA' ||
            tarefa.estadoDescricao == 'CANCELADA'
          "
          @click="cancelarTarefa"
        >
          CANCELAR TAREFA
        </button>
      </div>
      <!-- <button type="button" class="btn-editar">Editar</button> -->
    </div>

    <br />
    <br />
  </div>
  <div
    class="sub-tarefa-inputs-pai"
    v-if="AddSubTarefaCampo"
  >
    <div class="sub-tarefa-inputs">
      <div class="sub-tarefa-inputs-top">
        <h6>CADASTRAR SUBTAREFA</h6>
        <h6
          style="cursor: pointer"
          @click="((AddSubTarefaCampo = !AddSubTarefaCampo), (erro = ''))"
        >
          X
        </h6>
      </div>
      <div class="sub-tarefa-all-inputs">
        <div class="btns">
          <div class="subTarefa-titulo-input">
            <label>Título:</label>
            <input
              v-model="SubTarefaTituloInput"
              type="text"
              id="input-titulo"
            />
          </div>
          <div id="subTarefa-responsavel-input">
            <div class="sub-tarefa-input">
              <label for="">Data de início:</label>
              <input
                type="date"
                name=""
                id=""
                required
                v-model="dataInicio"
              />
            </div>
            <div class="sub-tarefa-input">
              <label for="">Data de término:</label>
              <input
                type="date"
                name=""
                id=""
                required
                v-model="dataFim"
              />
            </div>
          </div>
        </div>
        <div class="div-sub-tarefa-btn">
          <div
            v-if="erro"
            class="error-message"
          >
            {{ erro }}
          </div>
          <div
            v-if="dataInicioEFimMaiorAtual"
            class="error-message"
          >
            {{ dataInicioEFimMaiorAtual }}
          </div>
          <button
            class="sub-tarefa-btn"
            type="submit"
            @click="addSubTarefa"
          >
            CRIAR
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="sub-tarefa-inputs-pai"
    v-if="avisoPorcentagem"
  >
    <div class="sub-tarefa-inputs">
      <div
        class="sub-tarefa-inputs-pai"
        v-if="aviso"
      >
        <div class="sub-tarefa-inputs">
          <div class="sub-tarefa-inputs-top">
            <h6>AVISO</h6>
            <h6
              style="cursor: pointer"
              @click="aviso = !aviso"
            >
              X
            </h6>
          </div>
          <div class="sub-tarefa-all-inputs">
            <div class="btns">
              <div class="subTarefa-titulo-input subTarefa-titulo-input-aviso">
                <i
                  class="fa-solid fa-circle-check fa-5x"
                  style="color: #27d41b"
                ></i>
                <h4>Subtarefa criada com sucesso!</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="sub-tarefa-inputs-pai"
    v-if="EditSubTarefaCampo"
  >
    <div class="sub-tarefa-inputs-pai">
      <div class="sub-tarefa-inputs">
        <div class="sub-tarefa-inputs-top">
          <h6>EDITAR SUBTAREFA</h6>
          <h6
            style="cursor: pointer"
            @click="
              ((EditSubTarefaCampo = !EditSubTarefaCampo), (erroEdicao = ''))
            "
          >
            X
          </h6>
        </div>
        <div class="sub-tarefa-all-inputs">
          <div class="btns">
            <div class="subTarefa-titulo-input">
              <label>Título:</label>
              <input
                v-model="editSubTarefaTituloInput"
                type="text"
                id="input-titulo-edicao"
              />
            </div>
            <div id="subTarefa-responsavel-input">
              <div class="sub-tarefa-input">
                <label for="">Data de início:</label>
                <input
                  type="date"
                  name=""
                  id=""
                  required
                  v-model="editDataInicio"
                />
              </div>
              <div class="sub-tarefa-input">
                <label for="">Data de término:</label>
                <input
                  type="date"
                  name=""
                  id=""
                  required
                  v-model="editDataFim"
                />
              </div>
            </div>
          </div>
          <div class="div-sub-tarefa-btn">
            <div
              v-if="erroEdicao"
              class="error-message"
            >
              {{ erroEdicao }}
            </div>
            <div
              v-if="dataInicioEFimMaiorAtualEdicao"
              class="error-message"
            >
              {{ dataInicioEFimMaiorAtualEdicao }}
            </div>
            <button
              class="sub-tarefa-btn"
              type="submit"
              @click="editSubTarefa(subTarefa)"
            >
              SALVAR EDIÇÃO
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="sub-tarefa-inputs"
      v-if="avis"
    >
      <div class="sub-tarefa-inputs-top">
        <h6>AVISO</h6>
        <h6
          style="cursor: pointer"
          @click="avisoPorcentagem = !avisoPorcentagem"
        >
          X
        </h6>
      </div>
      <div class="sub-tarefa-all-inputs">
        <div class="btns">
          <div class="subTarefa-titulo-input subTarefa-titulo-input-aviso">
            <i
              class="fa-solid fa-circle-check fa-5x"
              style="color: #27d41b"
            ></i>
            <h4>Percentual alterado com sucesso!</h4>
          </div>
        </div>
      </div>
    </div>
  </div>

  <AdicionarMembrostarefa
    v-if="viewAlocarMembros"
    :tarefa="tarefa"
    :acaoId="props.id"
    :membros="time"
    @close="((viewAlocarMembros = false), atualizarDadosTarefa())"
  ></AdicionarMembrostarefa>
  <Aviso
    v-if="aviso == true"
    :sucesso="sucessoSubtarefa"
    :texto="textoAvisoSubtarefa"
    @fecharModal="aviso = !aviso"
  ></Aviso>
  <ModalDeConfirmacao
    :texto="textoConfirmacao"
    v-if="modalConfirmacaoView"
    @confirmacao="
      (confirmacao) => {
        if (confirmacao) {
          excluirSubtarefa();
        }
        modalConfirmacaoView = false;
      }
    "
  ></ModalDeConfirmacao>
</template>
<script setup>
import { onMounted, ref, watchEffect, computed } from "vue";
import {
  formatarData,
  formatarDataHora,
  formatarEnum,
  getLocalDateTime,
} from "@/utils/FormatarEntradas";
import acaoService from "@/service/acaoService";
import tarefaService from "@/service/tarefaService";
import userInfos from "@/utils/userInfos";
import atividadeService from "@/service/atividadeService";
import AdicionarMembrostarefa from "@/components/tarefas/AdicionarMembrostarefa.vue";
import Aviso from "@/components/common/aviso.vue";
import { useRoute } from "vue-router";
import ModalDeConfirmacao from "@/components/common/modalDeConfirmacao.vue";
import Carregamento from "@/components/common/Carregamento.vue";

const props = defineProps({
  tarefaId: {
    type: String,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
});

const carregando = ref(false);

const viewAlocarMembros = ref(false);
const tarefa = ref({});
const route = useRoute();
const nomeUsuario = ref("");
const lider = ref(false);
const status = ref(false);
const AddColaboradorCampo = ref(false);
const AddSubTarefaCampo = ref(false);
// const subTarefaFinalizada = ref(false);
const dataAtual = ref("");
const colaboradores = ref([]);
const membrosEquipeAtividade = ref([]);
const subTarefas = ref([]);
const mensagens = ref([]);
const membroSelecionado = ref({});
const SubTarefaTituloInput = ref("");
const mensagemInput = ref("");
const isCordenadorAcao = ref(false);
const membros = ref([]);
const user = userInfos.getUserInfos();
const time = ref();
const sucessoSubtarefa = ref(false);
const textoAvisoSubtarefa = ref("");
const dataInicio = ref();
const dataFim = ref();
const membroAlocado = ref(false);
const subTarefa = ref({});
const subtarefa = ref(null);
const subTarefasAbertas = ref([]);
const erro = ref("");
const aviso = ref(false);
const avisoPorcentagem = ref(false);
const EditSubTarefaCampo = ref(false);
const editSubTarefaTituloInput = ref("");
const editDataInicio = ref("");
const editDataFim = ref("");
const erroEdicao = ref("");
const modalConfirmacaoView = ref(false);
const textoConfirmacao = ref("");
const subTarefaSelecionadaExclusao = ref(null);
const mensagensDoUsuario = computed(() => {
  return mensagens.value.filter((msg) => msg.autor === nomeUsuario.value);
});

const mensagensDeOutros = computed(() => {
  return mensagens.value.filter((msg) => msg.autor == nomeUsuario.value);
});

function verificarStatusSubtarefa(subtarefa) {
  if (subtarefa.status) {
    return "Concluída";
  }

  return "Fazendo";
}

async function seVoluntariar() {
  const response = await tarefaService.voluntariarTarefa(tarefa.value.id);
  if (response.status >= 200 && response.status < 300) {
    sucessoSubtarefa.value = true;
    textoAvisoSubtarefa.value = "Você se voluntariou para essa tarefa!";
    aviso.value = true;
    tarefa.value = await tarefaService.getTarefaById(tarefa.value.id);
  } else if (response.status >= 400 && response.status < 500) {
    sucessoSubtarefa.value = false;
    textoAvisoSubtarefa.value = response.data.message;
    aviso.value = true;
  } else {
    sucessoSubtarefa.value = false;
    textoAvisoSubtarefa.value =
      "Ocoreu um erro no servidor, aguarde até que seja ajeitado!";
    aviso.value = true;
  }
}

async function getSubtarefas() {
  const response = await tarefaService.getSubTarefas(0, 1000, tarefa.value.id);

  if (response?.status == 200) {
    subTarefas.value = response.data.content;
  }
}

function toggleSubtarefas(index) {
  if (!subTarefasAbertas.value.includes(index)) {
    subTarefasAbertas.value.push(index);
  } else {
    const indiceExclusao = subTarefasAbertas.value.indexOf(index);

    subTarefasAbertas.value.splice(indiceExclusao, 1);
  }
}

function verificarSubtarefaAberta(index) {
  if (subTarefasAbertas.value.includes(index)) {
    return true;
  }

  return false;
}

function verificarExclusao() {
  const estado = tarefa.value.estadoDescricao;

  if (estado == "PARA_FAZER" || estado == "EM_ANDAMENTO") {
    return true;
  }

  return false;
}

function verificarEdicao() {
  const estado = tarefa.value.estadoDescricao;

  if (estado == "PARA_FAZER" || estado == "EM_ANDAMENTO") {
    return true;
  }

  return false;
}

function isSubtarefaCreator(subtarefa) {
  return subtarefa.membroCriador === nomeUsuario.value;
}

function openEditSubTarefaCampo(subtarefa) {
  if (subtarefa.status) {
    alert("Não é possível editar uma subtarefa concluída.");
    return;
  }
  subTarefa.value = subtarefa;
  EditSubTarefaCampo.value = true;
}
async function excluirSubtarefaModalConfirmacao(subtarefa) {
  subTarefaSelecionadaExclusao.value = subtarefa;
  textoConfirmacao.value =
    "Você tem certeza que deseja excluir essa subtarefa?";
  modalConfirmacaoView.value = true;
}
async function concluirSubtarefa(subtarefa) {
  const response = await tarefaService.concluirSubTarefa(subtarefa.id);

  if (response?.status == 200) {
    location.reload();
  }
}
async function excluirSubtarefa() {
  const response = await tarefaService.deleteSubTarefa(
    subTarefaSelecionadaExclusao.value.id
  );
  if (response?.status == 200) {
    location.reload();
  }
}

async function cancelarTarefa() {
  const mensagem = confirm("Você tem certeza que deseja cancelar essa tarefa?");
  if (mensagem) {
    const response = await tarefaService.cancelarTarefa(tarefa.value.id);
    if (response.status >= 200 && response.status < 300) {
      alert("Tarefa cancelada com sucesso!");
    } else if (response.status >= 400 && response.status < 500) {
      alert("Houve algum erro nos seus dados!");
    } else {
      alert("Erro no servidor, tente novamente!");
    }
  }
}
async function mudarEstado() {
  const mensagem = confirm(
    "Você tem certeza que deseja alterar o estado desta tarefa?"
  );
  if (mensagem) {
    const response = await tarefaService.transitarEstadoTarefa(tarefa.value.id);
    tarefa.value.estadoDescricao = response.estadoDescricao;
    alert("O estado da tarefa foi alterado com sucesso!");
  } else {
    alert("Mudança de estado não efetuada!");
  }
}

async function carregarMembros(acao) {
  const acaoNome = await acaoService.getAcoesById(acao);
  if (acaoNome.titulo == tarefa.value.acaoNome) {
    membros.value = await acaoService.getMembrosTime(acao);
    membros.value.map((membro) => {
      if (user.nome == membro.nome) {
        if (membro.funcaoMembro == "COORDENADOR") {
          isCordenadorAcao.value = true;
        }
      }
    });
  } else {
    isCordenadorAcao.value = false;
  }
}

async function buscarTime(tarefa) {
  try {
    time.value = await atividadeService.getGrupoAtividade(tarefa.atividadeId);
  } catch (error) {
    console.log(error);
  }
}

let porcentagemAtual = ref();
let porcentagemNova = ref();
let alterarPorcentagem = ref(false);

/** Essa função apenas muda o estado do botão de 'alterar progresso' para 'fechar' */
function alterarProgresso() {
  alterarPorcentagem.value = !alterarPorcentagem.value;
}

async function putPorcentagem() {
  if (porcentagemAtual.value == porcentagemNova.value) {
    erro.value = "Porcentagem nova igual a atual!";
    return;
  }

  if (porcentagemNova.value == 100) {
    const confirmacao = confirm(
      "Ao determinar o progresso em 100% você irá automáticamente concluir a tarefa, deseja alterar o progresso ainda assim?"
    );

    if (confirmacao) {
      const response = await tarefaService.putPorcentagemTarefa(
        tarefa.value.id,
        porcentagemNova.value
      );
      if (response.status == 200) {
        avisoPorcentagem.value = true;
        tarefa.value = await tarefaService.getTarefaById(tarefa.value.id);
        alert("Tarefa concluída!");
        location.reload();
      }
      if (response.status >= 400 && response.status < 500) {
        alert(response.data.message);
        porcentagemNova = porcentagemAtual;
      }
      if (response.status >= 500) {
        alert("Ocoreu um erro no servidor, aguarde até que seja ajeitado!");
      }
      erro.value = "";
      alterarProgresso();
    }
  } else {
    const response = await tarefaService.putPorcentagemTarefa(
      tarefa.value.id,
      porcentagemNova.value
    );
    if (response.status == 200) {
      avisoPorcentagem.value = true;
      tarefa.value = await tarefaService.getTarefaById(tarefa.value.id);
      location.reload();
    }
    if (response.status >= 400 && response.status < 500) {
      alert(response.data.message);
      porcentagemNova = porcentagemAtual;
    }
    if (response.status >= 500) {
      alert("Ocoreu um erro no servidor, aguarde até que seja ajeitado!");
    }
    erro.value = "";
    alterarProgresso();
  }
}

function finalizarSubTarefa(index) {
  subTarefas.value[index].finalizada = true;

  dataAtual.value = new Date().toLocaleDateString();
}

function enviarMensagem() {
  if (mensagemInput.value.trim()) {
    const msg = {
      autor: nomeUsuario.value,
      mensagem: mensagemInput.value,
    };

    mensagens.value.push(msg);

    mensagemInput.value = "";
  }
}

function gerarCampoAddColaborador() {
  AddColaboradorCampo.value = !AddColaboradorCampo.value;
}

async function addColaborador() {
  const payload = {
    membrosTimeId: [membroSelecionado.value.id],
  };

  try {
    await tarefaService
      .alocarTarefa(tarefa.value.id, payload)
      .then(async () => {
        membroSelecionado.value = {};
        tarefa.value = await tarefaService.getTarefaById(tarefa.value.id);
        gerarCampoAddColaborador();
      });
  } catch (error) {
    console.log(error);
    alert(error.data.message);
  }
}

const dataInicioEFimMaiorAtual = computed(() => {
  if (!dataInicio.value || !dataFim.value) return "";

  const inicio = new Date(getLocalDateTime(dataInicio.value, "ISO"));
  const fim = new Date(getLocalDateTime(dataFim.value, "ISO"));
  const atual = new Date();

  atual.setHours(0, 0, 0, 0);

  if (fim < inicio) {
    return `data de término está menor que a data de início, não pode!`;
  }

  if (inicio < atual && fim < atual) {
    const dataAtualFormatada = new Date().toLocaleDateString("pt-BR");
    return `As datas estão anteriores a ${dataAtualFormatada} e a subtarefa será dada como CONCLUÍDA ao salvar.`;
  }

  return "";
});
async function addSubTarefa() {
  const titulo = SubTarefaTituloInput.value.trim();

  // Limpa mensagens de erro anteriores (exceto a computed)
  erro.value = "";

  if (!titulo || !dataInicio.value || !dataFim.value) {
    erro.value = "Preencha todos os dados!";
    return;
  }

  // Converte as datas para objetos Date
  const inicio = new Date(getLocalDateTime(dataInicio.value, "ISO"));
  const fim = new Date(getLocalDateTime(dataFim.value, "ISO"));

  // Validação 1: Data início não pode ser maior que data fim
  if (inicio > fim) {
    erro.value = "Data de início não pode ser maior que data de fim!";
    return;
  }
  subTarefa.value = {
    titulo: titulo,
    dataInicio: getLocalDateTime(dataInicio.value, "ISO"),
    dataFim: getLocalDateTime(dataFim.value, "ISO"),
    tarefaId: tarefa.value.id,
  };
  const response = await tarefaService.postSubTarefa(subTarefa.value);
  if (response.status > 300 && response.status < 500) {
    sucessoSubtarefa.value = false;
    textoAvisoSubtarefa.value = "Ocorreu algum erro ao criar a subTarefa";
    aviso.value = true;
    recarregarPagina();
  } else {
    textoAvisoSubtarefa.value = "subTarefa criada com sucesso!";
    sucessoSubtarefa.value = true;
    aviso.value = true;
    AddSubTarefaCampo.value = !AddSubTarefaCampo.value;
    limparFormSubtarefas();
  }
}
function recarregarPagina() {
  location.reload();
}
function limparFormSubtarefas() {
  SubTarefaTituloInput.value = "";
  dataInicio.value = "";
  dataFim.value = "";
  erro.value = "";
}
async function editSubTarefa() {
  const payload = {
    titulo: editSubTarefaTituloInput.value,
    dataInicio: getLocalDateTime(editDataInicio.value, "ISO"),
    dataFim: getLocalDateTime(editDataFim.value, "ISO"),
  };

  try {
    const response = await tarefaService.putSubTarefa(
      tarefa.value.id,
      subTarefa.value.id,
      payload
    );

    if (response.status >= 200 && response.status < 300) {
      textoAvisoSubtarefa.value = "SubTarefa editada com sucesso!";
      sucessoSubtarefa.value = true;
      aviso.value = true;
      editSubTarefaTituloInput.value = "";
      editDataInicio.value = "";
      editDataFim.value = "";
      EditSubTarefaCampo.value = false;
      getSubtarefas();
    } else if (response?.data?.message) {
      erroEdicao.value = response.data.message;
    }
  } catch (error) {
    erroEdicao.value =
      error?.response?.data?.message || "Erro ao editar subtarefa.";
  }
}

function atualizarStatus() {
  status.value = !status.value;
}

function playHoras(index) {
  subTarefas.value[index].paused = !subTarefas.value[index].paused;
}

function addSubTarefaCampo() {
  AddSubTarefaCampo.value = !AddSubTarefaCampo.value;
}

watchEffect(() => {
  colaboradores.value = tarefa.value.usuariosNomes; //atualiza a lista de colaboradoes
  porcentagemAtual.value = tarefa.value.percentualConclusao; // atualiza a porcentagem
});

async function atualizarDadosTarefa() {
  await carregarMembros(props.id);

  tarefa.value = await tarefaService.getTarefaById(props.tarefaId);

  lider.value = await userInfos.verificarLiderancaAtividade(
    tarefa.value.atividadeId
  );
  if (tarefa.value.atividadeId != null) {
    buscarTime(tarefa.value);
    membrosEquipeAtividade.value = (
      await atividadeService.getGrupoAtividade(tarefa.value.atividadeId)
    )?.Membros; //Busca os membros da equipe da atividade atrelada a tarefa}
  }
  colaboradores.value = tarefa.value.usuariosNomes;
}
async function carregarInformacoes() {
  carregando.value = true;
  const response = await tarefaService.getTarefaById(props.tarefaId);
  tarefa.value = response;
  porcentagemNova.value = tarefa.value.percentualConclusao;

  membroAlocado.value = tarefa.value.usuariosNomes.includes(nomeUsuario.value);
  carregando.value = false;
}

onMounted(async () => {
  nomeUsuario.value = userInfos.getUserInfos().nome;
  await carregarInformacoes();
  atualizarDadosTarefa();
  getSubtarefas();
});
</script>

<style scoped>
.error-message {
  color: var(--vermelho);
}

.aviso {
  width: 100%;
  height: 100%;
}

#button-finalizar {
  padding: 3px 20px;
  background-color: var(--azul-escuro);
  color: var(--branco);
  border-radius: 5px;
  border: none;
}

#button-finalizar:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: var(--cinza);
  color: var(--preto);
}

.sub-tarefa-inputs-pai {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.sub-tarefa-inputs {
  background-color: var(--branco);
  border: none;
  border-radius: 15px;
  width: 600px;
  max-width: 90vw;
  max-height: 90vh;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.7);
  z-index: 1001;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.sub-tarefa-inputs-top {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: var(--azul-escuro);
  border-radius: 15px 15px 0 0;
  padding: 15px 0;
  position: relative;
  min-height: 50px;
}

.sub-tarefa-inputs-top h6:first-child {
  color: var(--branco);
  font-weight: bold;
  margin: 0;
  text-align: center;
}

.sub-tarefa-inputs-top h6:last-child {
  position: absolute;
  top: 0;
  right: 0;
  padding: 3px 30px;
  border-radius: 0px 15px 0px 0px;
  background-color: var(--vermelho);
  color: var(--branco);
  margin: 0;
  cursor: pointer;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 100%;
}

.sub-tarefa-all-inputs {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.btns {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 5px;
}

.subTarefa-titulo-input {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.subTarefa-titulo-input-aviso {
  display: flex;
  align-items: center;
  justify-content: center;
}

.subTarefa-titulo-input label {
  font-weight: 500;
  font-size: 16px;
}

#subTarefa-responsavel-input {
  display: flex;
  flex-direction: row;
  gap: 15px;
}

.sub-tarefa-input {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.sub-tarefa-input input {
  padding: 5px 10px;
  border-radius: 5px;
  border: var(--cinza) 2px groove !important;
}

#input-titulo {
  padding: 5px 10px;
  border-radius: 5px;
  border: var(--cinza) 2px groove !important;
}

.div-sub-tarefa-btn {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
}

.sub-tarefa-btn {
  padding: 8px 25px;
  background-color: var(--azul-escuro);
  color: var(--branco);
  border-radius: 5px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
}

.sub-tarefa-btn:hover {
  background-color: var(--roxo-escuro);
}

/* Estilo específico para o modal de progresso */
.num-porcentagem {
  width: 3vw;
}

.btn-porcentagem {
  accent-color: var(--roxo-header);
  width: 100%;
  margin: 10px 0;
}

.sub-tarefa-btn-porcentagem {
  margin-top: 20px;
}

.error-message {
  color: var(--vermelho);
  text-align: center;
  font-size: 14px;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.div-button-editar {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 40px;
  padding: 20px 0;
  gap: 10px;
}

#finalizar-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.btn-editar {
  border: none;
  background-color: var(--roxo-header);
  color: var(--branco);
  padding: 10px 40px;
  border-radius: 5px;
}
.btn-editar-subtarefa {
  background-color: var(--laranja) !important;
}

.fa-solid {
  transition: all 0.3s;
}

.girarSeta {
  transform: rotateZ(90deg);
}

#content-tarefa {
  padding: 50px;
}

#top-content-tarefa {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

#titulo-tarefa {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 80%;
}

.titulo-e-estado {
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: center;
  justify-content: center;
  margin: 0;
  margin-bottom: 5px;

  & span {
    background-color: var(--azul-escuro);
    color: var(--branco);
    padding: 5px 30px;
    border-radius: 10px;
  }
}

#descricao-tarefa {
  margin-top: 5px;
  width: 100%;

  & p {
    text-align: justify;
  }

  & p span:first-child {
    font-weight: 600;
  }
}

#progresso {
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 0;
}

.progressoAlterar {
  flex-direction: column;
  gap: 20px;
}

.form-porcentagem {
  display: flex;
  gap: 10px;

  & input {
    padding: 5px 20px;
    border-radius: 7px;
  }
}

#middle-content-tarefa {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
}

.contribuidores-sub-tarefas {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

#contribuidores-bottom {
  margin-top: 10px;
  display: flex;
  align-items: flex-start;

  flex-direction: column;
  gap: 10px;

  & p {
    margin: 0;
  }

  & div {
    display: flex;
    flex-direction: row;
    gap: 10px;
    margin-left: 20px;
  }
}

#sub-tarefas {
  width: 80%;
}

#sub-tarefa-top {
  display: flex;
  align-items: center;
  margin: 0;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
}

#sub-tarefa-middle {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  gap: 40px;
  max-height: 50vh;
  overflow-y: auto;
}

.sub-tarefas-for {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  gap: 10px;
}

.sub-tarefa {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.sub-tarefa-aberta {
  background-color: var(--cinza);
  border-radius: 0px 0px 20px 0px;
  width: 100%;
  padding: 10px 30px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
  max-height: 200px;
  height: 150px;
}

.sub-tarefa-data {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.criador-sub-tarefa div {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.sub-tarefa-botoes {
  display: flex;
  position: absolute;
  right: 10px;
  bottom: 10px;
  gap: 10px;
}

.sub-tarefa-botoes button {
  background-color: var(--roxo-claro);
  color: var(--branco);
  padding: 5px 15px;
  border-radius: 7px;
  border: none;
}
.sub-tarefa-botoes button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: var(--cinza);
  color: var(--preto);
}

.sub-tarefa p {
  width: 100%;
  border-radius: 0px 20px 20px 0px;
  background-color: var(--azul-escuro);
  padding: 10px 10px;
  color: var(--branco);
}

.subTarefaAbertaP {
  border-radius: 0px 20px 0px 0px !important;
}

.comentarios-main {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background-color: var(--cinza);
  max-width: 475px;
  width: 100%;
  max-height: 400px;
  border-radius: 10px 10px 20px 20px;
  height: 322px;
}

.comentarios-main h6 {
  text-align: center;
  color: var(--branco);
  width: 100%;
  padding: 10px 0px;
  border-radius: 10px 10px 0px 0px;
  background-color: var(--azul-escuro);
  margin-bottom: 0;
}

.comentarios-content {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 250px;
  height: 250px;
  padding: 40px;
  gap: 15px;
}

.comentario-usuario-logado,
.comentario-outro-usuario {
  width: 80%;
  padding: 10px;
  border-radius: 8px;
  max-width: 380px;
  word-break: break-word;
  /* Quebra apenas entre palavras */
}

.comentario-usuario-logado {
  /* Azul claro para usuário logado */
  background-color: var(--branco);
  align-self: flex-end;
  margin-left: 20%;
  text-align: end;
}

.comentario-outro-usuario {
  background-color: var(--branco);
  /* Cinza claro para outros usuários */
  align-self: flex-start;
  margin-right: 20%;
  text-align: start;
}

.comentario-usuario-logado h5,
.comentario-outro-usuario h5 {
  font-weight: bold;
  margin-bottom: 5px;
  color: #333;
}

.comentario-usuario-logado p,
.comentario-outro-usuario p {
  margin: 0;
  color: #555;
}

.comentarios-input {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
  width: 90%;
}

.comentarios-input input {
  border-radius: 20px;
  padding: 8px 15px;
  border: 1px solid #ccc;
}

.comentarios-input input:focus {
  border: var(--roxo-escuro) 2px solid;
  outline: none;
}

.comentarios-input button {
  border-radius: 7px;
  padding: 5px 20px;
  color: var(--branco);
  background-color: var(--roxo-header);
  border: none;
  cursor: pointer;
}

.comentarios-input button:hover {
  background-color: var(--roxo-escuro);
}

/* Estilos para a barra de rolagem */
.comentarios-content::-webkit-scrollbar {
  width: 10px;
}

.comentarios-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.comentarios-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

.comentarios-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* estilos globais do botão nessa tela */

.tarefa-btn {
  padding: 2px 5px;
  border-radius: 7px;
  background-color: var(--branco);
  color: var(--roxo-escuro);
  border: var(--roxo-escuro) 2px groove;
  transition: all 0.2s;
  cursor: pointer;
}

.tarefa-btn:hover {
  color: var(--branco);
  border: none;
  background-color: var(--roxo-escuro);
  border: var(--roxo-escuro) 2px groove;
}

.tarefa-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: var(--cinza);
  color: var(--preto);
}

@media (max-width: 1098px) {
  .sub-tarefa-aberta {
    flex-direction: column;
  }
}

@media (max-width: 941px) {
  .sub-tarefa-aberta {
    width: 100%;
    max-width: 300px;
    height: 100%;
  }

  .sub-tarefa-botoes {
    position: inherit;
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-top: 30px;
    gap: 10px;
    justify-content: center;
  }
}
</style>
